var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-width":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }